import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";
import TryItButton from "../../../TryItButton";
import OutputBox from "../../../OutputBox";

export default function JS_IfElse() {
  return (
    <div className="tutorial-container read-only">
      <h1 className="tutorial-title">🟡 JavaScript if...else Statement</h1>

      <p className="tutorial-intro">
        The <code className="highlight_code">if...else</code> statement helps
        handle two possible outcomes. If the condition is true, one block runs;
        otherwise, the else block runs. Think of it as — “If you pass,
        celebrate; else, study again!”
      </p>

      <div
        className="Key_point_container"
        style={{ background: "linear-gradient(135deg, #fef9c3, #fde68a)" }}
      >
        <h2 style={{ color: "#854d0e" }}>🔑 Key Points</h2>
        <ul className="tutorial-list-points">
          <li>Used for true/false decisions.</li>
          <li>Ensures only one block executes at a time.</li>
          <li>Perfect for user validation or status checks.</li>
        </ul>
      </div>

      {/* Example 1 */}
      <div className="tutorial-section">
        <h2 className="section-title">1️⃣ Exam Result Example</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let marks = 40;
if (marks >= 50) {
  console.log("Pass - Congratulations from Edu-Tech Master Academy!");
} else {
  console.log("Fail - Please try again.");
}`}
          />
          <TryItButton
            code={`let marks = 40;
if (marks >= 50) {
  console.log("Pass - Congratulations from Edu-Tech Master Academy!");
} else {
  console.log("Fail - Please try again.");
}`}
          />
        </div>
        <OutputBox>
          <pre>Fail - Please try again.</pre>
        </OutputBox>
      </div>

      {/* Example 2 */}
      <div className="tutorial-section">
        <h2 className="section-title">2️⃣ Subscription Check</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let isPremium = false;
if (isPremium) {
  console.log("Welcome to Premium Edu-Tech Master Academy courses!");
} else {
  console.log("Please upgrade to access all features.");
}`}
          />
          <TryItButton
            code={`let isPremium = false;
if (isPremium) {
  console.log("Welcome to Premium Edu-Tech Master Academy courses!");
} else {
  console.log("Please upgrade to access all features.");
}`}
          />
        </div>
        <OutputBox>
          <pre>Please upgrade to access all features.</pre>
        </OutputBox>
      </div>

      {/* Example 3 */}
      <div className="tutorial-section">
        <h2 className="section-title">3️⃣ Attendance Requirement</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let attendance = 85;
if (attendance >= 75) {
  console.log("Eligible for final exam at Edu-Tech Master Academy.");
} else {
  console.log("Not eligible due to low attendance.");
}`}
          />
          <TryItButton
            code={`let attendance = 85;
if (attendance >= 75) {
  console.log("Eligible for final exam at Edu-Tech Master Academy.");
} else {
  console.log("Not eligible due to low attendance.");
}`}
          />
        </div>
        <OutputBox>
          <pre>Eligible for final exam at Edu-Tech Master Academy.</pre>
        </OutputBox>
      </div>

      {/* Next Steps */}
      <div
        style={{
          background: "linear-gradient(135deg, #fde68a, #fcd34d)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2 style={{ color: "#92400e" }}>🚀 Next Steps</h2>
        <ul className="tutorial-list-points">
          <li>
            Use nested <code className="highlight_code">if...else</code> for
            deeper logic.
          </li>
          <li>
            Try applying <code className="highlight_code">if...else</code> to
            UI-based decisions.
          </li>
          <li>
            Next, learn{" "}
            <code className="highlight_code">if...else if...else</code> for
            multi-condition handling.
          </li>
          <li>
            Explore <code className="highlight_code">switch</code> for cleaner
            multi-branch checks.
          </li>
        </ul>
      </div>
    </div>
  );
}
